import { useState, useRef, useEffect } from 'react';

export default function useRefState(init, bind) {
  const [state, _setState] = useState(init);
  const stateRef = useRef(state);
  const setState = (value) => {
    stateRef.current = typeof value === 'function' ? value(state) : value;
    _setState(value);
  };

  useEffect(() => setState(init), [bind && init]);
  useEffect(() => () => { stateRef.current = undefined; }, []);

  return [state, setState, stateRef];
}
